import React from 'react';
import { Grid, CircularProgress } from '@dripcapital/dripui-v1';

type Props = object;

const CircularLoader: React.FC<Props> = () => {
  return (
    <Grid
      dataTestId="circular-loader-element"
      container
      alignItems="center"
      _sx={{
        justifyContent: 'center',
        width: '100%',
        height: '99vh',
      }}
    >
      <CircularProgress color="primary" />
    </Grid>
  );
};

export default CircularLoader;
